/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { IonIcon, IonImg, IonModal } from "@ionic/react";
import {
  chevronBackOutline,
  chevronForward,
  chevronForwardOutline,
  handRight,
} from "ionicons/icons";
import { FC, useEffect, useState } from "react";
import Page from "../components/Page";
import photo1 from "../resources/photo1.jpeg";
import photo2 from "../resources/photo2.png";
import photo3 from "../resources/photo3.jpg";
import { IonButton } from "@ionic/react";
const Home: React.FC = () => {
  const randomNum = (x: number, y: number) => {
    return Math.floor(Math.random() * (y - x + 1) + x!);
  };

  const images = [
    photo1,
    // photo3,
    // "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(" +
    //   randomNum(1, 133) +
    //   ").webp",
    // "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(" +
    //   randomNum(1, 133) +
    //   ").webp",
    // "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(" +
    //   randomNum(1, 133) +
    //   ").webp",
    // "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(" +
    //   randomNum(1, 133) +
    //   ").webp",
    // "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(" +
    //   randomNum(1, 133) +
    //   ").webp",
    // "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(" +
    //   randomNum(1, 133) +
    //   ").webp",
    // "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(" +
    //   randomNum(1, 133) +
    //   ").webp",
    // "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(" +
    //   randomNum(1, 133) +
    //   ").webp",
    // "https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(" +
    //   randomNum(1, 133) +
    //   ").webp",
  ];
  // random num number generator from x to y

  useEffect(() => {
    console.log("Home page loaded");
    // console.log(randomNum(1, 999));
  }, []);

  return (
    <Page title="Gallery">
      {/* <SlideShow images={[]} /> */}
      <GalleryCollage interval={5000} images={images} />
    </Page>
  );
};

export default Home;

const GalleryCollage: FC<{ images: Array<string>; interval?: number }> = ({
  images,
  interval,
}) => {
  const [currentImage, setCurrentImage] = useState<number | undefined>(
    undefined
  );
  const [showModal, setShowModal] = useState(false);
  const [isPlaying, setIsPlaying] = useState(showModal);

  function handleForward() {
    if (currentImage === undefined) return;
    setCurrentImage((currentImage + 1) % images.length);
  }

  function handleBackward() {
    if (currentImage === undefined) return;
    setCurrentImage((currentImage - 1 + images.length) % images.length);
  }

  function handlePlay() {
    setIsPlaying(true);
  }

  function handlePause() {
    setIsPlaying(false);
  }

  // useEffect(() => {
  //   if (isPlaying) {
  //     setInterval(() => {
  //       handleForward();
  //     }, interval);
  //   }
  // }, [showModal]);

  // useEffect(() => {
  //   if (currentImage === undefined) return;
  //   if (showModal && interval && currentImage) {
  //     // handlePlay();
  //     setInterval(() => {
  //       handleForward();
  //     }, interval);
  //   }
  // }, [showModal]);

  return (
    <section className="overflow-hidden text-gray-700 ">
      <div className="container px-5 py-2 mx-auto lg:pt-12 lg:px-32">
        <IonModal
          className=""
          isOpen={showModal}
          onDidDismiss={() => setShowModal(false)}
        >
          <div className=" mt-[33%] z-50">
            <IonButton
              onClick={handleForward}
              className=" float-right w-[80px] h-[80px] border-r-50"
              fill="clear"
            >
              <IonIcon icon={chevronForwardOutline} />
            </IonButton>
            <IonButton
              onClick={handleBackward}
              className=" float-left w-[80px] h-[80px] border-r-50"
              fill="clear"
            >
              <IonIcon icon={chevronBackOutline} />
            </IonButton>
          </div>
          <img
            className=" transition-all duration-500 ease-in-out
            w-[100%] h-[100%] object-cover object-center absolute inset-0 "
            src={images[currentImage as any]}
          />
        </IonModal>
        <div className="flex flex-wrap -m-1 md:-m-1">
          {images.map((image, index) => (
            <div key={index} className="flex flex-wrap w-1/3">
              <div className="w-full p-1 md:p-2">
                <img
                  onClick={() => {
                    setCurrentImage(index);
                    setShowModal(true);
                  }}
                  alt="gallery"
                  className=" cursor-pointer transition-all duration-500 ease-in-out transform hover:scale-105 block object-contain object-center w-full h-full rounded-lg"
                  src={image}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const SlideShow: FC<{ images: Array<string>; interval?: number }> = ({
  images,
  interval,
}) => {
  return (
    <div
      id="carouselExampleIndicators"
      className="carousel slide carousel-fade"
      data-mdb-ride="carousel"
    >
      <div className="carousel-inner mb-5">
        <div className="carousel-item active">
          <img
            src="https://mdbcdn.b-cdn.net/img/Photos/Slides/img%20(88).webp"
            className="d-block w-100"
            alt="..."
          />
        </div>
        <div className="carousel-item">
          <img
            src="https://mdbcdn.b-cdn.net/img/Photos/Slides/img%20(121).webp"
            className="d-block w-100"
            alt="..."
          />
        </div>
        <div className="carousel-item">
          <img
            src="https://mdbcdn.b-cdn.net/img/Photos/Slides/img%20(31).webp"
            className="d-block w-100"
            alt="..."
          />
        </div>
      </div>

      <button
        className="carousel-control-prev"
        type="button"
        data-mdb-target="#carouselExampleIndicators"
        data-mdb-slide="prev"
      >
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button
        className="carousel-control-next"
        type="button"
        data-mdb-target="#carouselExampleIndicators"
        data-mdb-slide="next"
      >
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>

      <div className="carousel-indicators" style={{ marginBottom: "-20px" }}>
        <button
          type="button"
          data-mdb-target="#carouselExampleIndicators"
          data-mdb-slide-to="0"
          className="active"
          aria-current="true"
          aria-label="Slide 1"
          style={{ width: "100px" }}
        >
          <img
            className="d-block w-100 img-fluid"
            src="https://mdbcdn.b-cdn.net/img/Photos/Others/Carousel-thumbs/img%20(88).webp"
          />
        </button>
        <button
          type="button"
          data-mdb-target="#carouselExampleIndicators"
          data-mdb-slide-to="1"
          aria-label="Slide 2"
          style={{ width: "100px" }}
        >
          <img
            className="d-block w-100 img-fluid"
            src="https://mdbcdn.b-cdn.net/img/Photos/Others/Carousel-thumbs/img%20(121).webp"
          />
        </button>
        <button
          type="button"
          data-mdb-target="#carouselExampleIndicators"
          data-mdb-slide-to="2"
          aria-label="Slide 3"
          style={{ width: "100px" }}
        >
          <img
            className="d-block w-100 img-fluid"
            src="https://mdbcdn.b-cdn.net/img/Photos/Others/Carousel-thumbs/img%20(31).webp"
          />
        </button>
      </div>
    </div>
  );
};
